import { TableColumn } from "react-data-table-component";
import { DataRow } from "./types";
import { stringWithDefault } from "utils/data-table-utils";
import { Button, Chip } from "@mui/material";
import { colors } from "styles/variables";
import { RowingRounded } from "@material-ui/icons";
import { VoicemessageTitleLink, NewActivity } from "pages/UserDetails/styles";
import { Feature } from "types/api";

export const CREATE_PLAYLIST_COLUMNS: TableColumn<DataRow>[] = [
  {
    name: "ID",
    selector: (row) => row.id,
    omit: true,
  },
  {
    name: "Title",
    selector: (row) => stringWithDefault(row.title),
    cell: (row) => (
      <Button
        href={`/activity-details/${row.id}`}
        rel="noreferrer noopener"
        target="_blank"
        sx={{ textTransform: "none" }}
      >
        {stringWithDefault(row.title)}
      </Button>
    ),
    sortable: true,
    wrap: true,
  },
  {
    name: "Difficulty",
    selector: (row) => row.difficulty || "-",
    sortable: true,
    cell: (row) => {
      if (
        row.feature === Feature.HealthyBrainActivity ||
        row.feature === Feature.CompensatoryStrategies
      ) {
        return row.difficulty || "-";
      }
      return "-";
    },
  },
  {
    name: "Recorder",
    selector: (row) => row.recorder,
    cell: (row) => row.recorder,
    sortable: true,
    wrap: true,
  },
  {
    name: "Prev. Used",
    selector: (row) => row.previouslyUsed,
    cell: (row) =>
      row.previouslyUsed ? (
        <Chip
          style={{ backgroundColor: `${colors.red}`, color: `${colors.gray2}` }}
          label="Used"
        />
      ) : (
        ""
      ),
    sortable: true,
    wrap: true,
  },
  {
    name: "Activity Created",
    selector: (row) => row?.newlyCreated ?? "",
    cell: (row) =>
      row.newlyCreated ? (
        <NewActivity> {row?.newlyCreated ? row?.newlyCreated : ""}</NewActivity>
      ) : (
        ""
      ), // Ensure it returns null if no value
    sortable: true,
    wrap: true,
  },
  {
    name: "Activity Template Link",
    selector: (row) => (row.templateLink ? row?.templateLink : ""),
    cell: (row) =>
      row.templateLink ? (
        <VoicemessageTitleLink onClick={() => window.open(row?.templateLink)}>
          {row.templateLink}
        </VoicemessageTitleLink>
      ) : (
        ""
      ),
    wrap: true,
  },
  // {
  //   name: "Length",
  //   selector: (row) => row.length,
  //   sortable: true,
  //   wrap: true,
  // },
  {
    name: "Cog Domain",
    selector: (row) => row.cognitiveDomains?.join(", ") || "-",
    sortable: true,
    wrap: true,
  },
  {
    name: "Recording",
    selector: (row) => row.recording ?? "",
    cell: (row) => (
      <audio src={row.recording ?? ""} controls preload="metadata" />
    ),
    grow: 2,
  },
];
